// Step 3: Create ConfirmationModal.jsx component
import { Link } from "react-router-dom";

const ConfirmationModal = ({ isSuccess, errorMessage, onClose }) => {
  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-70'>
      <div className='bg-white rounded-md shadow-xl max-w-md w-full'>
        <div className='max-h-[94vh] overflow-y-auto'>
          {isSuccess ? (
            <div className='flex flex-col items-center justify-center min-h-[150px] py-8 px-2 w-full'>
              <div className='flex justify-center mb-0'>
                <img
                  src='/assets/img/iq_tick.gif'
                  alt='Success'
                  className='w-12 h-12 mb-0'
                />
              </div>
              <h2 className='text-center font-[Oxanium] text-[22px] text-inaqpurple font-medium mb-0'>
                Odber potvrdený
              </h2>
              <p className='font-rubik text-[14px] sm:text-[13px] leading-[20px] text-inaqgold inline-block mb-12 sm:mb-8 sm:mx-4 mx-8 text-center'>
                Ďakujeme, práve sme potvrdili vašu adresu a zaradili ju do
                zoznamu odberateľov pre B2B² newsletter. Najnovšie vydanie už
                príde aj vám!
              </p>
              <div className='flex space-x-4 mt-2'>
                <Link
                  to='/blog'
                  className='border-[1px] border-inaqgold border-solid btn-md font-medium font-rubik bg-transparent text-inaqgold hover:text-inaqgold hover:text-opacity-80 py-2 px-4 rounded-sm btn btn-secondary'
                  style={{ "--text-color": "#fff" }}
                >
                  Prejsť na blog
                </Link>
                <button
                  type='button'
                  onClick={onClose}
                  className='border-[1px] border-inaqgold border-solid btn-md font-normal font-rubik bg-inaqgold text-white py-2 px-4 rounded-sm btn btn-secondary'
                  style={{ "--text-color": "#fff" }}
                >
                  Zatvoriť
                </button>
              </div>
            </div>
          ) : (
            <div className='flex flex-col items-center justify-center min-h-[150px] py-8 px-2 w-full'>
              <div className='flex justify-center mb-0'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  className='w-12 h-12 text-red-500'
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
                  />
                </svg>
              </div>
              <h2 className='text-center font-[Oxanium] text-[22px] text-inaqpurple font-medium mb-0'>
                Chyba pri potvrdení
              </h2>
              <p className='font-rubik text-[14px] sm:text-[13px] leading-[20px] text-inaqgold inline-block mb-12 sm:mb-8 sm:mx-4 mx-8 text-center'>
                {errorMessage ||
                  "Nastala chyba pri potvrdzovaní odberu. Prosím, skúste sa zaregistrovať znovu."}
              </p>
              <div className='flex space-x-4 mt-2'>
                <button
                  type='button'
                  onClick={onClose}
                  className='border-[1px] border-inaqgold border-solid btn-md font-normal font-rubik bg-inaqgold text-white py-2 px-4 rounded-sm btn btn-secondary'
                  style={{ "--text-color": "#fff" }}
                >
                  Zatvoriť
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
